<template>
  <div id="app">
    <!-- <Navbar /> -->
    <transition name="slide-fade">
      <Navbar v-if="$store.state.auth.user" />
    </transition>
    <!-- <div class="modal-bg"></div> -->
    <!-- <transition name="router-transition"> -->
    <router-view class="router-view" />
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  components: {
    Navbar: require("@/components/Navbar").default
  },
  data() {
    return {
      activeModalBg: false
    };
  },
  created() {
    let self = this;
  }
};
</script>

<style lang="scss" scoped>
#app {
  /* padding-bottom: 192px; */
  /* min-height: 100vh;
  box-sizing: border-box; */
}
.modal-bg {
  width: 100%;
  height: 100%;
  /* filter: blur(5px); */

  z-index: 15;
  position: fixed;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100222000;
  }
}

.router-transition-enter-active {
  animation: fadeIn 0.3s;
  animation-delay: 0.3s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    /* transform: translateX(-20px); */
    opacity: 0;
  }
  to {
    /* transform: translateX(0); */
    opacity: 1;
  }
}

.router-transition-leave-active {
  animation: fadeOut 0.3s;
}

@keyframes fadeOut {
  from {
    /* transform: translateX(0); */
  }
  to {
    /* transform: translateX(-20px); */
    opacity: 0;
  }
}

//nav bar transition

/* enter、 leave アニメーションで異なる間隔やタイミング関数を利用することができます */
.slide-fade-enter-active {
  transition: all 0.3s ease;
  transition-delay: 0.3s;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
